import { useCallback, useEffect, useRef, useState } from "react";

const CHIAVE = "mab_chat_audio";

// Tre rintocchi morbidi crescenti per i messaggi in chat: solo sulle postazioni,
// lo Schermo Sala resta dedicato al suono di chiamata.
export function useNotificaChat() {
  const ctxRef = useRef(null);
  const [attivo, setAttivo] = useState(() => localStorage.getItem(CHIAVE) !== "off");

  const getCtx = useCallback(() => {
    if (!ctxRef.current) {
      const Ctx = window.AudioContext || window.webkitAudioContext;
      if (!Ctx) return null;
      ctxRef.current = new Ctx();
    }
    return ctxRef.current;
  }, []);

  useEffect(() => {
    const sblocca = () => {
      const ctx = getCtx();
      if (ctx && ctx.state === "suspended") ctx.resume().catch(() => {});
    };
    window.addEventListener("pointerdown", sblocca);
    window.addEventListener("keydown", sblocca);
    return () => {
      window.removeEventListener("pointerdown", sblocca);
      window.removeEventListener("keydown", sblocca);
    };
  }, [getCtx]);

  const cambia = useCallback((v) => {
    setAttivo(v);
    localStorage.setItem(CHIAVE, v ? "on" : "off");
  }, []);

  const play = useCallback(() => {
    if (!attivo) return;
    const ctx = getCtx();
    if (!ctx || ctx.state === "suspended") return;
    const t0 = ctx.currentTime + 0.02;
    const master = ctx.createGain();
    master.gain.setValueAtTime(0.55, t0);
    master.connect(ctx.destination);

    [
      { freq: 659.25, delay: 0 },
      { freq: 830.61, delay: 0.16 },
      { freq: 987.77, delay: 0.32 },
    ].forEach(({ freq, delay }) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.setValueAtTime(freq, t0 + delay);
      gain.gain.setValueAtTime(0.0001, t0 + delay);
      gain.gain.exponentialRampToValueAtTime(0.55, t0 + delay + 0.025);
      gain.gain.exponentialRampToValueAtTime(0.0001, t0 + delay + 0.6);
      osc.connect(gain).connect(master);
      osc.start(t0 + delay);
      osc.stop(t0 + delay + 0.65);
    });
  }, [attivo, getCtx]);

  return { play, attivo, setAttivo: cambia };
}
